import { render, staticRenderFns } from "./travelIndex.vue?vue&type=template&id=f1facbd8&scoped=true"
import script from "./travelIndex.vue?vue&type=script&lang=js"
export * from "./travelIndex.vue?vue&type=script&lang=js"
import style0 from "./travelIndex.vue?vue&type=style&index=0&id=f1facbd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1facbd8",
  null
  
)

export default component.exports